import { useEffect, useState } from "react";
import { Card, Table } from "antd";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { masteruri } from "../../config";
import { myfetchThunk } from "../../app/myfetch";
import { cardmargin } from "../CSSReferences";
import { DownloadTotal, downloadsPath, overall, parseTotals } from "./setup_downloads";

// How often the public installation package was downloaded, per version
// (16.10.2026). Shown on the Updates page for admins; resumed downloads are
// not counted twice, and the hub keeps nothing about who downloaded.
export function SetupDownloads() {
    const intl = useIntl();
    const dispatch = useDispatch();
    const [totals, setTotals] = useState<DownloadTotal[]>([]);

    useEffect(() => {
        dispatch(myfetchThunk(true, downloadsPath(masteruri), {}, "GET",
            (json: unknown) => setTotals(parseTotals(json)),
            () => setTotals([])) as any);
    }, [dispatch]);

    const t = (id: string, defaultMessage: string, values?: Record<string, number>) =>
        intl.formatMessage({ id, defaultMessage }, values);
    const sum = overall(totals);

    return (
        <Card style={cardmargin} size="small"
              title={t("SetupDownloads:Title", "Installer downloads: {total} in total, {lastDays} in the last 30 days, {today} today",
                       { total: sum.total, lastDays: sum.lastDays, today: sum.today })}>
            <Table<DownloadTotal>
                size="small"
                rowKey="version"
                pagination={false}
                dataSource={totals}
                locale={{ emptyText: t("SetupDownloads:Empty", "No downloads yet") }}
                columns={[
                    { title: t("SetupDownloads:Version", "Version"), dataIndex: "version" },
                    { title: t("SetupDownloads:Today", "Today"), dataIndex: "today", align: "right" },
                    { title: t("SetupDownloads:LastDays", "Last 30 days"), dataIndex: "lastDays", align: "right" },
                    { title: t("SetupDownloads:Total", "Total"), dataIndex: "total", align: "right" },
                ]}
            />
        </Card>
    );
}
